export const defaultEntity = 'accountOperatori';
export const entities = ['accountOperatori'];
export const labels = {
    accountOperatori: 'Account operatori',
};